// extracted by mini-css-extract-plugin
export default {"container":"EditRoomPage_container__l-b8-","patientQueue":"EditRoomPage_patientQueue__F5KK8"};